export default "__VITE_ASSET__HUi3d3Gu__"